import type { SubjectConfig } from "@shikaku/shared";

export const config: SubjectConfig = {
  name: "EnergyManagerMaster",
  nameJa: "エネルギー管理士マスター",
  primaryColor: "#167076",
  questionFileJa: "/data/questions_ja.json",
  units: [
    "課目I エネルギー総合管理",
    "課目I 法規",
    "熱分野 課目II 熱と流体の基礎",
    "熱分野 課目III 燃料と燃焼",
    "熱分野 課目IV 熱利用設備",
    "電気分野 課目II 電気の基礎",
    "電気分野 課目III 電気設備及び機器",
    "電気分野 課目IV 電力応用",
  ],
  totalQuestionCount: 802,
  shufflesChoiceOrder: true,
  usesUnitModeSelection: true,
  hasMockExam: true,
};

export const NAMESPACE = "energy-manager";
